/* eslint-disable prefer-destructuring */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable quotes */
/* eslint-disable react/jsx-curly-brace-presence */
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    Typography,
    Box,
    Button,
    Table,
    TableHead,
    TableCell,
    TableBody,
    TableRow
  } from '@material-ui/core';
  
  const Grammar_Self_Instructions = (props) => {
    const assessmentType = props.assessmentType;
    const participantName = props.participantname;
    const assessorName = props.assessorname;
    const relation = props.relation;
    return (
      <>
        <Grid container spacing={6} wrap="wrap">
        <Grid item lg={6} md={6} sm={6} sx={12} xs={12}>
          <Typography
            style={styles.nameStyle}
            color="textPrimary"
            gutterBottom
            variant="body1"
          >
            {`Participant Name : ${participantName}`}
          </Typography>
        </Grid>
          <Grid item lg={6} md={6} sm={6} sx={12} xs={12}>
            <Box
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginBottom: 10
              }}
            >
              <img
                alt="Logo"
                width={70}
                height={55}
                src="/static/logo.png"
                {...props}
              />
            </Box>
          </Grid>
        </Grid>
        <Card style={styles.cardStyle}>
        <CardHeader
          color="primary"
          title="Instructions"
          style={styles.cardHeaderStyle}
        />
        <Divider />
        <CardContent style={styles.cardContentStyle}>
          <Grid container spacing={6} wrap="wrap">
            <Grid item md={12} sm={12} sx={12} xs={12}>
              <Typography color="textPrimary" variant="body2">
                Hi Respondent,{' '}
                {/* <p style={{ marginTop: 20 }}>
                  This questionnaire is about your perception of the assesse
                </p> */}
              </Typography>
              <ul style={styles.listWrapInsStyle}>
                <li style={styles.listInsStyle}>
                  <Typography color="textPrimary" variant="body2">
                    {`As part of the communication skills development initiative, you are requested to complete a grammar assessment designed to evaluate your proficiency in written grammar. This assessment will help us understand your current level and plan necessary development actions.
`}
                  </Typography>
                </li>
                <li style={styles.listInsStyle}>
                  <Typography color="textPrimary" variant="body2">
                    {`This questionnaire is to evaluate your grammar proficiency`}
                  </Typography>
                </li>
                <li style={styles.listInsStyle}>
                  <Typography color="textPrimary" variant="body2">
                    {`You must answer all the questions below including the qualitative sections`}
                  </Typography>
                </li>
                <li style={styles.listInsStyle}>
                  <Typography color="textPrimary" variant="body2">
                    {`This will soley be used for your development purposes`}
                  </Typography>
                </li>
                {/* <li style={styles.listInsStyle}>
                  <Typography color="textPrimary" variant="body2">
                    {`As far as possible try to base your answers on critical instances
              of this person's communication. The marking scale is 1-4 where "1" is
              the lowest and "4" is the highest score.`}
                  </Typography>
                </li> */}
              </ul>
              {/* <Typography
                color="textPrimary"
                variant="body2"
                style={{ marginTop: 20 }}
              >
                {`If the question is entirely not applicable to the participant, you can choose the “NA” option. But please choose the option only when you don't
              have any critical incidents. You can score by selecting the given
              options.`}
              </Typography> */}
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2
          }}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={props.handleStartClick}
          >
            Start
          </Button>
        </Box>
      </Card>
      </>
    );
  };
  
  const styles = {
    nameStyle: {
      margin: 10
    },
    cardStyle: {
      boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.35)',
      borderRadius: 10
    },
    cardContentStyle: {
      marginLeft: 10
    },
    listWrapInsStyle: {
      marginLeft: 20
      
    },
    listInsStyle: {
      paddingTop: 5    
    },
    cardHeaderStyle: {
      color: '#f77445',
      backgroundColor: '#f4f4f4'
    }
  };
  
  export default Grammar_Self_Instructions;
  